import React from 'react';

export default function LoginPage() {
  return (
    <div className="login-page">
      <h1>Time Entry</h1>
      <p>Professional Services Timesheet System</p>
      <a href="/auth/login" className="btn btn-primary" style={{ textDecoration: 'none' }}>
        Sign in with Microsoft
      </a>
    </div>
  );
}
